import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LookupService } from '../services/lookup.service';
import { switchMap } from 'rxjs/operators';
import { Country } from '../models/country';

@Pipe({ name: 'countryName' })
export class CountryNamePipe implements PipeTransform {
  constructor(private lookupService: LookupService) {}
  transform(country: Country): Observable<string> {
    if (country.name) {
      return of(country.name);
    }
    return this.lookupService.countries.pipe(
      switchMap((countries: Country[]) => {
        const matchingCountry = countries.find((c) => c.id === country.id);
        return matchingCountry ? of(matchingCountry.name) : of(countries[0].name);
      })
    );
  }
}
